import React, { createContext, useContext, useState } from "react";

const SettingsSearchContext = createContext(null);

export function SettingsSearchProvider({ children }) {
  const [tabSearch, setTabSearch] = useState("");
  return <SettingsSearchContext.Provider value={{ tabSearch, setTabSearch }}>
    {children}
  </SettingsSearchContext.Provider>;
}

export function useSettingsSearch() {
  return useContext(SettingsSearchContext);
}
